import { SITE, PLANS } from "@/data/site";
import { faqJsonLd } from "@/components/FAQ";

/**
 * Route-level structured data for the homepage.
 *
 * The site-wide EducationalOrganization / Person / WebSite graph lives in index.html
 * as static markup, because that is the only version non-JS crawlers ever see. This
 * file adds what is specific to "/" and references the static nodes by @id rather than
 * repeating them — that is what @id is for, and duplicating an entity under two
 * definitions is how a knowledge graph ends up with two of you.
 */

export const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${SITE.origin}/#webpage`,
    url: `${SITE.origin}/`,
    name: "AI Automation Base — Learn to Build the Systems. Then Own Them.",
    description:
      "An online school run by Hector Diaz: live follow-along classes where you install n8n, wire Postgres, connect Claude Code and own the system you build.",
    isPartOf: { "@id": `${SITE.origin}/#website` },
    about: { "@id": `${SITE.origin}/#organization` },
    primaryImageOfPage: `${SITE.origin}/og/home.png`,
    inLanguage: "en",
  },
  {
    "@context": "https://schema.org",
    "@type": "Course",
    "@id": `${SITE.origin}/#course`,
    name: "AI Automation Base membership",
    description:
      "Live follow-along classes and self-paced courses on Claude Code, n8n, AntiGravity, PostgreSQL and Docker, plus Build Packs that install a complete system on a machine you own.",
    provider: { "@id": `${SITE.origin}/#organization` },
    // Google requires one of these on Course; the membership is continuous enrolment.
    hasCourseInstance: {
      "@type": "CourseInstance",
      courseMode: "online",
      courseWorkload: "PT2H",
      instructor: { "@id": `${SITE.origin}/#hector-diaz` },
    },
    offers: PLANS.map((p) => ({
      "@type": "Offer",
      name: p.name,
      category: p.billingDuration ? "Subscription" : "Paid",
      price: String(p.amount),
      priceCurrency: "USD",
      url: `${SITE.origin}/#pricing`,
      availability: "https://schema.org/InStock",
      ...(p.billingDuration
        ? {
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              price: String(p.amount),
              priceCurrency: "USD",
              billingDuration: p.billingDuration,
            },
          }
        : {}),
    })),
  },
  faqJsonLd,
];

export default homeJsonLd;
